export type ConflictingTermByBuilder = Record<string, string>;

export enum AssignTermPopupConfirmationModal {
  Unassign,
  AssignBuilders,
}

export type UnassignModal = {
  type: AssignTermPopupConfirmationModal.Unassign;
  conflictingTermByBuilder: ConflictingTermByBuilder;
};
export type AssignBuildersModal = {
  type: AssignTermPopupConfirmationModal.AssignBuilders;
  builderIds: string[];
};

export type AssignTermPopupConfirmationModalState =
  | UnassignModal
  | AssignBuildersModal;
export type AssignTermPopupFormReturn = {
  selectedBuilderIds: string[];
};
